module.exports = __webpack_public_path__ + "img/empty-parcel.ec30d9f2.svg";